import { Component, OnInit } from '@angular/core';

import { AppStoreService } from '../../app-store.service';
import { FeatureCommonService } from '../feature-common.service';

@Component({
  selector: 'app-manage-notifications',
  host: { class: 'set-height' },
  template: `@if (initialized) {<manage-notifications (featureErrorEvent)="handleError($event)" (feature403Event)="handle403($event)" (feature404Event)="handle404($event)"></manage-notifications>}`,
  standalone: false
})
export class ManageNotificationsComponent implements OnInit {
  initialized = false;
  constructor(
    private readonly appStoreService: AppStoreService,
    private readonly featureCommonService: FeatureCommonService
  ) {}

  ngOnInit() {
    this.initialized = this.featureCommonService.initialize('manage-notifications');
  }

  handleError(event){
    this.appStoreService.setFeatureError(event.detail);
  }

  handle403(event){
    this.appStoreService.setFeature403(event.detail);
  }

  handle404(event){
    this.appStoreService.setFeature404(event.detail);
  }

}
